import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Phenomenon">
                            <h2>Pace Up To Through Research & Development To Make Your Idea A Global Phenomenon</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>Step into the world of digital products with our research and development and conquer wherever you go. Do not discriminate or undermine your imaginative skills; bring your idea to the forefront, discuss with, and it might be the best idea your industry space has seen.</p>
                        <p>From starting till the end, we accompany you, assisting you in every stage. We ensure a smooth and seamless project, delivering the best there is. We believe in building world-class solutions that serve the purpose in the short term and stay relevant in the long run.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;